<script lang="ts">
  // 7 · Notifications: turn on push for this device and pick the reminders.
  import { ArrowRight, BellRing, BellOff } from '@lucide/svelte';
  import { t } from '../../i18n.svelte';
  import { account } from '../../stores/account.svelte';
  import { Button, Notice, Toggle } from '../../ui';
  import StepIntro from './StepIntro.svelte';
  import { flow } from '../state.svelte';

  const n = $derived(account.notifications);
  const enabled = $derived(flow.push === 'granted' || flow.pushResult === 'enabled');
  const blocked = $derived(
    flow.push === 'unsupported' || flow.pushResult === 'unsupported' ? t('onb.notif.unsupported')
    : flow.push === 'denied' || flow.pushResult === 'denied' ? t('onb.notif.denied')
    : null
  );
</script>

<StepIntro kicker={t('onb.notif.kicker')} title={t('onb.notif.title')} lead={t('onb.notif.text')} />

{#if enabled}
  <Notice tone="success" icon={BellRing}>{t('onb.notif.enabled')}</Notice>
{:else if blocked}
  <Notice tone="neutral" icon={BellOff}>{blocked}</Notice>
{:else}
  <Notice tone="brand" icon={BellRing}>
    {flow.pushResult === 'failed' ? t('onb.notif.failed') : t('onb.notif.device')}
    {#snippet actions()}
      <Button variant="primary" size="sm" loading={flow.pushBusy} onclick={flow.turnOnPush}>{t('onb.notif.enable')}</Button>
    {/snippet}
  </Notice>
{/if}

<div class="toggles">
  <Toggle bind:checked={flow.notifLongTimer} label={t('onb.notif.long_timer')} description={t('onb.notif.long_timer_text', { hours: n.notifLongTimerHours })} />
  <Toggle bind:checked={flow.notifLongBreak} label={t('onb.notif.long_break')} description={t('onb.notif.long_break_text', { minutes: n.notifLongBreakMinutes })} />
  <Toggle bind:checked={flow.notifDaily} label={t('onb.notif.daily')} description={t('onb.notif.daily_text', { time: n.notifDailySummaryTime })} />
</div>

{#if n.notifQuietHours}
  <Notice variant="dashed" tone="neutral" icon={false}>{t('onb.notif.quiet', { from: n.notifQuietFrom, to: n.notifQuietTo })}</Notice>
{/if}

<div class="more">
  <Button variant="ghost" size="sm" onclick={flow.notifSettings}>
    {t('onb.notif.settings')}
    {#snippet iconRight()}<ArrowRight />{/snippet}
  </Button>
</div>

<style>
  .toggles { display: flex; flex-direction: column; gap: var(--space-3); padding: var(--space-3) var(--space-0_5) var(--space-1); }
  .more { margin-left: calc(var(--space-3) * -1); }
</style>
